import React, { useEffect, useState } from 'react';

import { Reason } from '../../../common/constants/reasons';
import styles from './styles.module.scss';

export const ReasonChoice = ({
  reason,
  active,
  selectionCallback,
}: {
  reason: Reason;
  active: boolean;
  selectionCallback: (reason: Reason) => void;
}) => {
  const [selected, setSelected] = useState(active);
  const classNames = [
    styles.ReasonCell,
    selected ? styles.ReasonSelected : styles.ReasonUnSelected,
  ];

  useEffect(() => {
    setSelected(active);
  }, [active]);

  const toggleSelection = () => {
    setSelected(!selected);
    selectionCallback(reason);
  };

  return (
    <div className={styles.ReasonBox} data-tid={reason.displayName}>
      <span
        className={classNames.join(' ')}
        onClick={() => {
          toggleSelection();
        }}
      >
        {reason.displayName}
      </span>
    </div>
  );
};
